import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './TermsAndConditions.css';

function TermsAndConditions() {
  const [activeTab, setActiveTab] = useState('terms');
  const location = useLocation();

  // Get the tab from URL parameters when component mounts or URL changes
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');

    if (tabParam && ['terms', 'return', 'delivery', 'privacy'].includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="term-condition-container">
      <div className="term-condition-box">
        {/* Header Section*/}
        <div className="term-condition-header">
          <h1 className="term-condition-title">Policies & Legal Information</h1>
        </div>

        {/* Tabs Section */}
        <div className="term-condition-tabs">
          <button
            className={`term-condition-tab ${activeTab === 'terms' ? 'active' : ''}`}
            onClick={() => handleTabClick('terms')}
          >
            Terms and Conditions
          </button>
          <button
            className={`term-condition-tab ${activeTab === 'return' ? 'active' : ''}`}
            onClick={() => handleTabClick('return')}
          >
            Return & Refund
          </button>
          <button
            className={`term-condition-tab ${activeTab === 'delivery' ? 'active' : ''}`}
            onClick={() => handleTabClick('delivery')}
          >
            Shipping & Delivery
          </button>
          <button
            className={`term-condition-tab ${activeTab === 'privacy' ? 'active' : ''}`}
            onClick={() => handleTabClick('privacy')}
          >
            Privacy Policy
          </button>
        </div>

        {/* Content Section */}
        <div className="term-condition-content">
          {/* Terms and Conditions */}
          <div className={`term-condition-pane ${activeTab === 'terms' ? 'active' : ''}`}>
            <div className="term-condition-section">
              <h2 className="term-condition-section-title">Terms &amp; Conditions</h2>
              <p className="term-condition-text"><strong>Terms of Use</strong></p>
              <p className="term-condition-text">
                Welcome to the official website of <strong>ARDENCY CONSTRUCTION &amp; TRADING SDN BHD
                201701013881(1228046-W)</strong> ("ACTSB", "we", "our", or "us"). By accessing, browsing, or using
                this website, you ("user", "you", or "your") acknowledge that you have read, understood, and
                agreed to be bound by these Terms of Use. If you do not agree, you must immediately discontinue
                access to this website.
              </p>
            </div>

            <ol className="term-condition-list">
              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Ownership and Intellectual Property</h3>
                <p className="term-condition-text">
                  1.1 All content on this website, including but not limited to text, graphics, logos, images,
                  product information, software, applications, and interface design, is the property of ARDENCY
                  CONSTRUCTION &amp; TRADING SDN BHD and is protected under Malaysian copyright, trademark, and
                  intellectual property laws.
                </p>
                <p className="term-condition-text">
                  1.2 No licence or right is granted to you in respect of any intellectual property owned by
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD. You must not reproduce, modify, distribute, display,
                  or otherwise use any part of this website for commercial purposes without our prior written consent.
                </p>
                <p className="term-condition-text">
                  1.3 Trademarks, logos, and service marks displayed on this website are registered and
                  unregistered marks owned by ARDENCY CONSTRUCTION &amp; TRADING SDN BHD or third parties. You must
                  not use them without prior authorization.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Accuracy of Information</h3>
                <p className="term-condition-text">
                  2.1 ARDENCY CONSTRUCTION &amp; TRADING SDN BHD makes reasonable efforts to ensure that
                  information displayed on this website is accurate and up to date. However, we do not guarantee
                  the completeness, accuracy, reliability, or suitability of the information.
                </p>
                <p className="term-condition-text">
                  2.2 All product descriptions, prices, availability, and specifications are provided for general
                  information only and are subject to change without notice. For confirmation of product details,
                  availability, and pricing, please contact ARDENCY CONSTRUCTION &amp; TRADING SDN BHD directly.
                </p>
                <p className="term-condition-text">
                  2.3 ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall not be liable for any direct, indirect, or
                  consequential losses or damages arising from reliance on any information provided on this website.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Limitation of Liability</h3>
                <p className="term-condition-text">
                  3.1 To the maximum extent permitted by law, ARDENCY CONSTRUCTION &amp; TRADING SDN BHD, its
                  directors, employees, agents, and affiliates shall not be liable for any loss, damage, expense,
                  or injury arising from:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Your use of, or inability to use, this website;</li>
                  <li className="term-condition-subitem">Any errors, omissions, or inaccuracies in website content;</li>
                  <li className="term-condition-subitem">
                    Any malware, viruses, or harmful code transmitted from this website or linked websites; or
                  </li>
                  <li className="term-condition-subitem">Any unauthorized access to or use of our servers or data.</li>
                </ul>
                <p className="term-condition-text">
                  3.2 Where liability cannot be excluded under applicable law, our liability shall be limited to
                  the resupply of the relevant service or information.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">User Obligations</h3>
                <p className="term-condition-text">
                  4.1 You agree to use this website only for lawful purposes and in compliance with these Terms of Use.
                </p>
                <p className="term-condition-text">4.2 You must not:</p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Attempt to hack, disrupt, or interfere with the operation of this website;</li>
                  <li className="term-condition-subitem">Upload, transmit, or distribute any harmful, offensive, or unlawful content;</li>
                  <li className="term-condition-subitem">Use this website for commercial purposes without our consent;</li>
                  <li className="term-condition-subitem">
                    Deep-link, scrape, or use automated means to access this website without authorization.
                  </li>
                </ul>
                <p className="term-condition-text">
                  4.3 You may display, download, or print content from this website solely for personal and
                  non-commercial use, provided that you do not alter or remove any copyright, trademark, or
                  proprietary notices.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Links to Third-Party Websites</h3>
                <p className="term-condition-text">
                  5.1 This website may contain links to external websites operated by third parties. These links
                  are provided for convenience only. ARDENCY CONSTRUCTION &amp; TRADING SDN BHD does not endorse,
                  control, or assume responsibility for the content, products, or services offered on those websites.
                </p>
                <p className="term-condition-text">
                  5.2 We make no warranties that linked websites are free from viruses, harmful components, or
                  infringement of intellectual property rights.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Linking to This Website</h3>
                <p className="term-condition-text">6.1 You may create a link to this website provided that:</p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    The full HTML page is displayed (not partial elements or embedded graphics);
                  </li>
                  <li className="term-condition-subitem">
                    The link does not misrepresent ARDENCY CONSTRUCTION &amp; TRADING SDN BHD or imply
                    sponsorship/endorsement without our written consent; and
                  </li>
                  <li className="term-condition-subitem">
                    The link does not lead to any restricted or secure areas of the website.
                  </li>
                </ul>
                <p className="term-condition-text">
                  6.2 If you wish to use ARDENCY CONSTRUCTION &amp; TRADING SDN BHD's logos or images for linking
                  purposes, prior written approval is required.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Website Availability and Security</h3>
                <p className="term-condition-text">
                  7.1 ARDENCY CONSTRUCTION &amp; TRADING SDN BHD does not guarantee uninterrupted access to this
                  website. The website may be unavailable due to maintenance, technical issues, or circumstances
                  beyond our control.
                </p>
                <p className="term-condition-text">
                  7.2 While ARDENCY CONSTRUCTION &amp; TRADING SDN BHD takes reasonable measures to protect this
                  website, we do not warrant that downloadable files, software, or programs are free from viruses
                  or other harmful code. You are responsible for implementing adequate security measures on your devices.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Privacy and Data Collection</h3>
                <p className="term-condition-text">
                  8.1 Any personal data collected through this website will be handled in accordance with our{' '}
                  <a
                    href="/terms?tab=privacy"
                    onClick={(e) => { e.preventDefault(); handleTabClick('privacy'); }}
                  >
                    <strong><em>Privacy Policy</em></strong>
                  </a>
                  , which forms part of these Terms of Use.
                </p>
                <p className="term-condition-text">
                  8.2 We may use cookies or similar technologies to enhance your browsing experience. By using
                  this website, you consent to the use of cookies, which you may disable through your browser settings.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Fees and Charges</h3>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to charge fees for access to
                  certain features, services, or sections of this website. If applicable, you will be notified in
                  advance before incurring any charges.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Governing Law and Jurisdiction</h3>
                <p className="term-condition-text">
                  10.1 These Terms of Use are governed by and construed in accordance with the laws of Malaysia.
                </p>
                <p className="term-condition-text">
                  10.2 Any disputes, claims, or legal proceedings arising from or related to the use of this
                  website shall be subject to the exclusive jurisdiction of the courts of Malaysia.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Amendments to Terms</h3>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to amend, modify, or update these
                  Terms of Use at any time without prior notice. Changes will take effect once posted on this
                  website. By continuing to use the website, you agree to be bound by the updated Terms.
                </p>
              </li>
            </ol>
          </div>

          {/* Return and Refund Policy */}
          <div className={`term-condition-pane ${activeTab === 'return' ? 'active' : ''}`}>
            <div className="term-condition-section">
              <h2 className="term-condition-section-title">Refund &amp; Return Policy</h2>
              <p className="term-condition-text">
                <strong>ARDENCY CONSTRUCTION &amp; TRADING SDN BHD 201701013881(1228046-W)</strong> ("ACTSB",
                "we", "our", or "us") is committed to providing quality products and excellent customer service.
              </p>
              <p className="term-condition-text">
                This Refund &amp; Return Policy applies to all purchases made through <strong>ARDENCY
                CONSTRUCTION &amp; TRADING SDN BHD</strong>'s website and online sales platforms. By placing an
                order with <strong>ARDENCY CONSTRUCTION &amp; TRADING SDN BHD</strong>, you acknowledge and agree
                to the terms set out in this policy.
              </p>
            </div>

            <ol className="term-condition-list">
              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Delivery Inspection &amp; General Return Requirements</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    Customers are responsible for inspecting all products immediately upon delivery, collection, or receipt.
                  </li>
                  <li className="term-condition-subitem">
                    Any shortages, incorrect items, visible damages, or defects must be reported to ARDENCY
                    CONSTRUCTION &amp; TRADING SDN BHD within <strong>three (3) calendar days</strong> from the
                    date of delivery, collection, or receipt of goods, whichever is later.
                  </li>
                  <li className="term-condition-subitem">
                    No returns, exchanges, or refunds will be accepted after the three (3) day period.
                  </li>
                </ul>
                <p className="term-condition-text"><strong>To qualify for a return, exchange, or refund:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    The product must be unused, uninstalled, unopened (where applicable), and in resaleable condition.
                  </li>
                  <li className="term-condition-subitem">The product must be returned in its original packaging.</li>
                  <li className="term-condition-subitem">
                    Proof of purchase, invoice, delivery order, or order confirmation must be provided.
                  </li>
                  <li className="term-condition-subitem">
                    All returned products are subject to inspection and approval by ARDENCY CONSTRUCTION &amp; TRADING SDN BHD.
                  </li>
                </ul>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to reject any request that does
                  not comply with this policy.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Returns of Non-Faulty Goods (Change of Mind)</h3>
                <p className="term-condition-text">
                  Subject to approval, customers may request a return or exchange for non-faulty products within
                  the permitted return period.
                </p>
                <p className="term-condition-text"><strong>The following conditions apply:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    All transportation, courier, shipping, collection, handling, and related costs shall be borne by the customer.
                  </li>
                  <li className="term-condition-subitem">Products must be returned in their original condition and packaging.</li>
                  <li className="term-condition-subitem">
                    Products showing signs of use, installation, damage, contamination, moisture exposure, stains,
                    missing parts, tampering, or improper storage will not be accepted.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to reject any return that fails inspection.
                  </li>
                </ul>
                <p className="term-condition-text">
                  Approved returns of non-faulty goods may be subject to a <strong>restocking fee of up to 15%</strong> of
                  the product value, together with any applicable transportation, handling, inspection, or administrative charges.
                </p>
                <p className="term-condition-text"><strong>Approved returns may be exchanged for:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">A similar product of equivalent value (subject to stock availability); or</li>
                  <li className="term-condition-subitem">Store Credit / Exchange Voucher.</li>
                </ul>
                <p className="term-condition-text"><strong>Store credits and exchange vouchers:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Are non-transferable;</li>
                  <li className="term-condition-subitem">Cannot be redeemed for cash; and</li>
                  <li className="term-condition-subitem">Are valid only for purchases from ARDENCY CONSTRUCTION &amp; TRADING SDN BHD.</li>
                  <li className="term-condition-subitem">Will only be issued after approval of the returned products.</li>
                </ul>
                <p className="term-condition-text">
                  Please allow approximately seven (7) to ten (10) working days for approved exchanges to be
                  processed, subject to stock availability.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Trade, Project &amp; Commercial Customers</h3>
                <p className="term-condition-text">
                  For contractors, developers, project customers, trade account holders, and commercial purchasers:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">A copy of the original invoice must be provided.</li>
                  <li className="term-condition-subitem">Approved returns will generally be issued as account credit only.</li>
                  <li className="term-condition-subitem">Commercial quantities are generally non-returnable.</li>
                </ul>
                <p className="term-condition-text"><strong>Commercial quantities include:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Bulk quantity purchases;</li>
                  <li className="term-condition-subitem">Purchases exceeding five (5) units per pallet;</li>
                  <li className="term-condition-subitem">Purchases exceeding one (1) metric ton;</li>
                  <li className="term-condition-subitem">Project-specific purchases; or</li>
                  <li className="term-condition-subitem">Special procurement orders.</li>
                </ul>
                <p className="term-condition-text">All returns remain subject to inspection and approval.</p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Non-Returnable &amp; Non-Refundable Products</h3>
                <p className="term-condition-text">
                  For quality control, safety, performance, hygiene, shelf-life, and operational reasons, the
                  following products are not eligible for return, exchange, or refund unless proven defective upon delivery:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Cement and cementitious materials;</li>
                  <li className="term-condition-subitem">Construction steel bars, wire mesh, and industrial metal products;</li>
                  <li className="term-condition-subitem">Timber, plywood, wood products, and related materials;</li>
                  <li className="term-condition-subitem">Products with expiry dates or limited shelf life;</li>
                  <li className="term-condition-subitem">Custom-made, special-order, indent, imported-by-request, or specially procured products;</li>
                  <li className="term-condition-subitem">Products cut, fabricated, processed, modified, or customised to customer specifications;</li>
                  <li className="term-condition-subitem">Tinted, mixed, or custom-coloured paints and coatings;</li>
                  <li className="term-condition-subitem">Waterproofing materials that have been opened or partially used;</li>
                  <li className="term-condition-subitem">Products exposed to moisture, chemicals, weather, contamination, or improper storage;</li>
                  <li className="term-condition-subitem">Products with damaged packaging, missing components, or signs of installation;</li>
                  <li className="term-condition-subitem">Products damaged due to misuse, mishandling, improper storage, or negligence by the customer; and</li>
                  <li className="term-condition-subitem">Promotional, clearance, discounted, or sale items unless defective.</li>
                </ul>
                <p className="term-condition-text">
                  Natural materials such as timber, plywood, wood-based products, natural stone, and cement-based
                  products may exhibit natural variations in colour, texture, grain, dimensions, pattern, or
                  appearance. Such natural variations are not considered defects and shall not be grounds for
                  return, exchange, or refund.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Faulty Products &amp; Warranty Claims</h3>
                <p className="term-condition-text">
                  If a product is delivered damaged, defective, incorrect, incomplete, or fails to meet acceptable
                  quality standards, customers may be entitled to:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Repair;</li>
                  <li className="term-condition-subitem">Replacement;</li>
                  <li className="term-condition-subitem">Exchange; or</li>
                  <li className="term-condition-subitem">Refund (for major defects where applicable).</li>
                </ul>
                <p className="term-condition-text">
                  Customers must notify ARDENCY CONSTRUCTION &amp; TRADING SDN BHD within <strong>three (3)
                  calendar days</strong> of receiving the product.
                </p>
                <p className="term-condition-text"><strong>Conditions</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Proof of purchase is required.</li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to inspect the product and
                    determine the appropriate remedy.
                  </li>
                  <li className="term-condition-subitem">Manufacturer warranty terms may apply where applicable.</li>
                  <li className="term-condition-subitem">
                    For minor defects, ARDENCY CONSTRUCTION &amp; TRADING SDN BHD may choose repair or replacement
                    instead of a refund.
                  </li>
                </ul>
                <p className="term-condition-text">
                  Our Customer Support Team will provide a <strong>Return Request Form</strong>, which must be
                  completed and returned before any return, exchange, or warranty claim can be processed.
                </p>
                <p className="term-condition-text">The appropriate resolution will be determined after inspection.</p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Refund Method &amp; Limitations</h3>
                <p className="term-condition-text">
                  All approved refunds will only be processed after ARDENCY CONSTRUCTION &amp; TRADING SDN BHD has
                  received, inspected, and approved the returned goods in accordance with this Refund &amp; Return Policy.
                </p>
                <p className="term-condition-text"><strong>Refund conditions:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD <strong>does not refund to the original payment method</strong>.
                  </li>
                  <li className="term-condition-subitem">All approved refunds will be made via <strong>bank transfer only</strong>.</li>
                  <li className="term-condition-subitem">Refunds can only be paid to a Malaysian bank account nominated by the customer.</li>
                  <li className="term-condition-subitem">Customers are responsible for providing accurate banking information.</li>
                  <li className="term-condition-subitem">Refunds are limited to the original purchase price of the approved returned products.</li>
                  <li className="term-condition-subitem">
                    Delivery charges, transportation fees, shipping fees, installation charges, handling fees, and
                    other service-related charges are non-refundable.
                  </li>
                </ul>
                <p className="term-condition-text">
                  Approved refunds are generally processed within seven (7) to fourteen (14) working days after final approval.
                </p>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to withhold refunds until the
                  returned products have been fully inspected and verified.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Free Gifts, Promotional Items &amp; Bundled Products</h3>
                <p className="term-condition-text">
                  Where a purchase includes free gifts, promotional products, vouchers, accessories, manuals,
                  warranty cards, certificates, or bundled items:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    All free gifts, accessories, manuals, warranty cards, certificates, vouchers, and promotional
                    items supplied with the original purchase must be returned together with the product.
                  </li>
                  <li className="term-condition-subitem">
                    If any free gift, promotional item, bundled product, voucher, or accessory is not returned,
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to deduct its retail value from
                    the refund amount.
                  </li>
                  <li className="term-condition-subitem">
                    Promotional benefits associated with the original purchase may be cancelled, adjusted, or
                    deducted from the refund amount where applicable.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Stock Availability &amp; Order Cancellation</h3>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD works with multiple manufacturers, suppliers, and
                  distributors to maintain product availability. However, stock availability is not guaranteed and
                  may change without prior notice.
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    Product availability displayed on the website may not always reflect real-time stock levels.
                  </li>
                  <li className="term-condition-subitem">
                    Stock quantities may fluctuate due to sales demand, supplier availability, inventory
                    adjustments, and replenishment schedules.
                  </li>
                  <li className="term-condition-subitem">
                    Products displayed as available may become unavailable after an order has been placed.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to delay, substitute, partially
                    fulfil, or cancel orders due to stock shortages, supplier issues, or circumstances beyond our control.
                  </li>
                </ul>
                <p className="term-condition-text"><strong>If stock shortages occur:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Available products may be delivered first;</li>
                  <li className="term-condition-subitem">Backordered products may be delivered upon stock replenishment; or</li>
                  <li className="term-condition-subitem">A refund equal to the purchase value of the unavailable item may be issued.</li>
                </ul>
                <p className="term-condition-text"><strong>Order Amendments &amp; Cancellations</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    Customers may request changes or cancellation of an order before the order has been processed,
                    packed, dispatched, shipped, customised, cut-to-size, tinted, specially procured, or otherwise
                    prepared for delivery.
                  </li>
                  <li className="term-condition-subitem">
                    Once an item has been ordered from a supplier, processed, packed, dispatched, shipped,
                    delivered, customised, cut-to-size, tinted, or specially prepared, modification or cancellation
                    request may be rejected or subject to reasonable cancellation charges.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Product Suitability, Specifications &amp; Images Disclaimer</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    Customers are responsible for ensuring that purchased products are suitable for their intended
                    application, project requirements, specifications, site conditions, and usage purposes.
                  </li>
                  <li className="term-condition-subitem">
                    Unless expressly confirmed in writing, ARDENCY CONSTRUCTION &amp; TRADING SDN BHD does not
                    guarantee that any product is suitable for a customer's specific project or intended application.
                  </li>
                  <li className="term-condition-subitem">
                    Product performance may vary depending on installation methods, workmanship, site conditions,
                    environmental conditions, storage practices, and maintenance procedures.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall not be liable for losses or damages arising
                    from improper installation, misuse, unsuitable application, or failure to follow manufacturer
                    recommendations.
                  </li>
                  <li className="term-condition-subitem">
                    Product photographs, illustrations, dimensions, specifications, colours, and descriptions
                    displayed on the website are provided for general reference only.
                  </li>
                  <li className="term-condition-subitem">
                    Actual products may vary due to manufacturing processes, production batches, supplier updates,
                    screen settings, lighting conditions, or natural material characteristics.
                  </li>
                  <li className="term-condition-subitem">
                    Such differences shall not constitute defects and shall not be grounds for return, exchange, or refund.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Online Purchase Returns &amp; Return Procedure</h3>
                <p className="term-condition-text">
                  To initiate a return, exchange, refund, or warranty claim, customers must contact ARDENCY
                  CONSTRUCTION &amp; TRADING SDN BHD within <strong>three (3) calendar days</strong> of receiving
                  the product.
                </p>
                <p className="term-condition-text">
                  <strong>WhatsApp:</strong>{' '}
                  <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">+60 12-482 5199</a>
                </p>
                <p className="term-condition-text"><strong>Customers must provide:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Order number or invoice number;</li>
                  <li className="term-condition-subitem">Reason for return, exchange, or claim;</li>
                  <li className="term-condition-subitem">Contact details; and</li>
                  <li className="term-condition-subitem">
                    Clear photographs of the product and packaging, and any defects or damages (if applicable).
                  </li>
                </ul>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    Failure to provide complete information may result in the return request being delayed or rejected.
                  </li>
                  <li className="term-condition-subitem">
                    Upon review, ARDENCY CONSTRUCTION &amp; TRADING SDN BHD may issue a Return Authorisation and
                    provide further instructions.
                  </li>
                  <li className="term-condition-subitem">
                    Products returned without prior approval may be rejected and returned at the customer's expense.
                  </li>
                  <li className="term-condition-subitem">
                    Approved returns must be securely packed in their original packaging and returned together with
                    all supplied accessories, manuals, warranty cards, vouchers, promotional items, and free gifts.
                  </li>
                  <li className="term-condition-subitem">
                    Return shipping and transportation costs shall be borne by the customer unless otherwise agreed
                    by ARDENCY CONSTRUCTION &amp; TRADING SDN BHD.
                  </li>
                  <li className="term-condition-subitem">
                    Customers are strongly encouraged to use a courier service with shipment tracking and insurance coverage.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Inspection, Rejection Rights &amp; Surplus Materials</h3>
                <p className="term-condition-text">All returned products are subject to inspection before approval.</p>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to reject any return, exchange,
                  refund, or warranty claim where:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Products show signs of use, installation, modification, or damage;</li>
                  <li className="term-condition-subitem">Packaging is incomplete or not original;</li>
                  <li className="term-condition-subitem">Products are contaminated by dust, cement, chemicals, moisture, or other substances;</li>
                  <li className="term-condition-subitem">Products have been cut, processed, tinted, opened, customised, or modified;</li>
                  <li className="term-condition-subitem">Products fall within the Non-Returnable Products category;</li>
                  <li className="term-condition-subitem">Proof of purchase is unavailable; or</li>
                  <li className="term-condition-subitem">The return request exceeds the permitted timeframe.</li>
                </ul>
                <p className="term-condition-text">
                  Products purchased in excess of project requirements, unused project balance stock, project
                  overruns, or leftover materials do not automatically qualify for return, exchange, or refund and
                  remain subject to ARDENCY CONSTRUCTION &amp; TRADING SDN BHD's approval.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Limitation of Liability &amp; Force Majeure</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    To the fullest extent permitted by law, ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall not be
                    liable for any indirect, consequential, incidental, special, punitive, or economic losses
                    arising from the purchase, delivery, installation, storage, or use of any product.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall not be responsible for project delays, labour
                    costs, installation costs, transportation costs, removal costs, business interruption, loss of
                    profit, or third-party claims.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall not be responsible for personal belongings,
                    documents, data, or other items left with returned products.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD's maximum liability shall be limited to the purchase
                    price paid for the affected product.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall not be liable for delays or failure to perform
                    obligations caused by circumstances beyond its reasonable control, including natural disasters,
                    floods, fires, pandemics, transportation disruptions, labour disputes, supplier shortages,
                    government actions, or other force majeure events.
                  </li>
                  <li className="term-condition-subitem">
                    Nothing in this policy excludes any rights that cannot legally be excluded under applicable Malaysian law.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Governing Law, Final Decision &amp; Policy Amendments</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    This Refund &amp; Return Policy shall be governed by and construed in accordance with the laws of Malaysia.
                  </li>
                  <li className="term-condition-subitem">
                    Any dispute arising from purchases made with ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall
                    be subject to the jurisdiction of the courts of Malaysia.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD's decision regarding product condition, inspection
                    results, and compliance with this policy shall be final, subject to any rights that cannot
                    legally be excluded under Malaysian law.
                  </li>
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to amend, update, modify, or
                    revise this Refund &amp; Return Policy at any time without prior notice. Any amendments shall
                    become effective upon publication on the website.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Contact Information</h3>
                <p className="term-condition-text">
                  For enquiries regarding returns, refunds, exchanges, warranty claims, or product issues, please contact:
                </p>
                <p className="term-condition-text">
                  <strong>Ardency Construction &amp; Trading Sdn. Bhd.</strong><br />
                  <strong>WhatsApp:</strong>{' '}
                  <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">+60 12-482 5199</a><br />
                  <strong>Address:</strong> No. 21, Jalan Wawasan 2C/KU7, Sungai Kapar Indah, 42200 Kapar, Klang, Selangor.<br />
                  <strong>Business Hours:</strong> Monday &ndash; Friday, 9:00 AM &ndash; 5:30 PM (excluding Public Holidays)
                </p>
              </li>
            </ol>

            {/* Return procedure */}
            <div className="term-condition-section">
              <h2 className="term-condition-section-title">To Return a Product</h2>
              <p className="term-condition-text">
                If the conditions stated above are met, you may proceed to return the product.
              </p>

              <h3 className="term-condition-item-title">Step 1</h3>
              <p className="term-condition-text">
                WhatsApp us at{' '}
                <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">+60 12-482 5199</a>{' '}
                within three (3) calendar days of receiving the product and provide:
              </p>
              <ul className="term-condition-sublist">
                <li className="term-condition-subitem">Order or invoice number;</li>
                <li className="term-condition-subitem">Photographs of the product; and</li>
                <li className="term-condition-subitem">Reason for return.</li>
              </ul>

              <h3 className="term-condition-item-title">Step 2</h3>
              <p className="term-condition-text">
                Our customer service will send you a <strong>Return Request Form</strong>. Please fill up the form
                and send it back to us.
              </p>

              <h3 className="term-condition-item-title">Step 3</h3>
              <p className="term-condition-text">
                Pack the product securely in its original manufacturer's packaging.
              </p>
              <p className="term-condition-text">
                The goods must be in new, unused, and resaleable condition and returned together with all
                accessories, manuals, warranty cards, certificates, promotional items, free gifts, vouchers, and
                any other items supplied with the original purchase.
              </p>
              <p className="term-condition-text">Please include a copy of the invoice inside the package.</p>

              <h3 className="term-condition-item-title">Step 4</h3>
              <p className="term-condition-text">Send the item to:</p>
              <p className="term-condition-text">
                <strong>Attn: WEBSITE RETURN DEPARTMENT (012-482 5199)</strong><br />
                <strong>ARDENCY CONSTRUCTION &amp; TRADING SDN BHD</strong><br />
                No. 21, Jalan Wawasan 2C/KU7,<br />
                Sungai Kapar Indah,<br />
                42200 Kapar, Klang, Selangor.
              </p>
            </div>

            <div className="term-condition-section">
              <h2 className="term-condition-section-title">To Return a Product in Person</h2>
              <p className="term-condition-text">
                Customers may alternatively return approved products directly to our warehouse.
              </p>
              <p className="term-condition-text"><strong>Before visiting:</strong></p>
              <ul className="term-condition-sublist">
                <li className="term-condition-subitem">Complete Steps 1 to 3 above; and</li>
                <li className="term-condition-subitem">
                  Contact us via{' '}
                  <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">
                    <strong>WhatsApp at 012-482 5199</strong>
                  </a>{' '}
                  to schedule your visit.
                </li>
                <li className="term-condition-subitem">Products are to be returned to our warehouse in Kapar, Selangor.</li>
              </ul>
              <p className="term-condition-text">
                Returns delivered in person must be made during our operating hours and remain subject to
                inspection and approval.
              </p>
            </div>

            <div className="term-condition-section">
              <h2 className="term-condition-section-title">Inspection &amp; Processing</h2>
              <p className="term-condition-text">Once the returned product has been received:</p>
              <ul className="term-condition-sublist">
                <li className="term-condition-subitem">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD will inspect the product to verify compliance with
                  this Refund &amp; Return Policy.
                </li>
                <li className="term-condition-subitem">
                  If the return is approved, the appropriate refund, exchange, replacement, repair, store credit,
                  or account credit will be processed.
                </li>
                <li className="term-condition-subitem">
                  Please allow approximately seven (7) to ten (10) working days for approved exchanges to be
                  processed, subject to stock availability.
                </li>
                <li className="term-condition-subitem">
                  Approved refunds are generally processed within seven (7) to fourteen (14) working days after
                  final approval.
                </li>
                <li className="term-condition-subitem">
                  Upon completion of inspection and quality verification, ARDENCY CONSTRUCTION &amp; TRADING SDN
                  BHD will endeavour to process approved claims within seven (7) business days. Actual processing
                  times may vary depending on product type, supplier verification requirements, and stock availability.
                </li>
              </ul>
              <p className="term-condition-text">
                Please contact our customer service via{' '}
                <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">
                  <strong>WhatsApp 012-482 5199</strong>
                </a>{' '}
                for more details.
              </p>
              <p className="term-condition-text">Please allow 48 hours for review and response.</p>
            </div>
          </div>

          {/* Delivery Information */}
          <div className={`term-condition-pane ${activeTab === 'delivery' ? 'active' : ''}`}>
            <div className="term-condition-section">
              <h2 className="term-condition-section-title">Shipping &amp; Delivery Policy</h2>
              <p className="term-condition-text">
                <strong>ARDENCY CONSTRUCTION &amp; TRADING SDN BHD 201701013881(1228046-W)</strong> ("ACTSB")
                is committed to delivering your orders efficiently and safely.
              </p>
              <p className="term-condition-text">
                <em>
                  All delivery timeframes provided are estimates only and may vary depending on product
                  availability, order quantity, delivery location, weather conditions, public holidays, traffic
                  conditions, and other unforeseen circumstances.
                </em>
              </p>
            </div>

            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <img
                src="/HowToOrder.png"
                alt="Delivery Information - How To Order"
                style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
              />
            </div>

            <ol className="term-condition-list">
              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Delivery Fees</h3>
                <p className="term-condition-text">
                  Delivery charges are <strong>not included</strong> in the product prices displayed on our
                  website unless otherwise stated.
                </p>
                <p className="term-condition-text">
                  Once your order is placed, our team will review the delivery location, order size, weight, and
                  quantity before providing a delivery quotation.
                </p>
                <p className="term-condition-text"><strong>Order Process:</strong></p>
                <p className="term-condition-text">
                  <em>
                    Order Placement &rarr; Product Payment &rarr; Delivery Fee Confirmation &rarr; Delivery Fee
                    Payment &rarr; Delivery Arrangement
                  </em>
                </p>
                <p className="term-condition-text">
                  Delivery will only be scheduled after <strong>FULL PAYMENT</strong> has been received.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Delivery Areas &amp; Lead Times</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    <strong>Klang Valley:</strong> Estimated delivery within <strong>5&ndash;7 working days</strong>{' '}
                    <em>(For reference only. Delivery may arrive earlier than estimated)</em>
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Peninsular Malaysia (Outside Klang Valley):</strong> Estimated delivery within{' '}
                    <strong>6&ndash;8 working days</strong>{' '}
                    <em>(For reference only. Delivery may arrive earlier than estimated)</em>
                  </li>
                </ul>
                <p className="term-condition-text">
                  Delivery lead time and charges will be quoted separately upon request. All delivery timelines
                  are subject to stock availability and delivery scheduling.
                </p>
                <p className="term-condition-text">
                  Kindly{' '}
                  <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">WhatsApp us</a>{' '}
                  to arrange your delivery schedule and obtain the latest delivery quotation (where applicable).
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Delivery Address &amp; Receiving of Goods</h3>
                <p className="term-condition-text">
                  Customers are responsible for providing accurate and complete delivery information, including:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Recipient's name</li>
                  <li className="term-condition-subitem">Contact number</li>
                  <li className="term-condition-subitem">Delivery address</li>
                  <li className="term-condition-subitem">Postcode</li>
                  <li className="term-condition-subitem">Company name (if applicable)</li>
                </ul>
                <p className="term-condition-text">
                  The customer or an authorized representative must be available to receive the goods at the
                  scheduled delivery time.
                </p>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD shall not be responsible for delays, failed
                  deliveries, or additional costs resulting from incorrect or incomplete delivery information.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Failed Delivery &amp; Redelivery</h3>
                <p className="term-condition-text">If delivery cannot be completed due to:</p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Incorrect delivery details;</li>
                  <li className="term-condition-subitem">Recipient unavailable;</li>
                  <li className="term-condition-subitem">Refusal to accept delivery;</li>
                  <li className="term-condition-subitem">Inaccessible delivery location;</li>
                </ul>
                <p className="term-condition-text">the order may be returned to our warehouse.</p>
                <p className="term-condition-text">
                  Additional redelivery, storage, or handling charges may apply.
                </p>
                <p className="term-condition-text">
                  Customers must contact us within <strong>3 working days</strong> to arrange redelivery.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Standard Delivery</h3>
                <p className="term-condition-text">
                  <strong>Delivery Timeframe: 5&ndash;8 Working Days</strong>{' '}
                  <em>(For reference only. Delivery may arrive earlier than estimated)</em>
                </p>
                <p className="term-condition-text">
                  Standard Delivery applies to most small and medium-sized orders.
                </p>
                <p className="term-condition-text">
                  Deliveries may be carried out by ARDENCY CONSTRUCTION &amp; TRADING SDN BHD's own fleet or
                  appointed third-party logistics providers.
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    For <strong>landed properties</strong>, goods will be delivered to the nearest accessible
                    ground-level area.
                  </li>
                  <li className="term-condition-subitem">
                    For <strong>apartments, condominiums, offices, factories, and commercial buildings</strong>,
                    delivery will be limited to the security area, reception, loading bay, or designated unloading zone.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Bulk &amp; Oversized Deliveries</h3>
                <p className="term-condition-text">
                  <strong>Delivery Timeframe: 7&ndash;14 Working Days</strong>{' '}
                  <em>(For reference only. Delivery may arrive earlier than estimated)</em>
                </p>
                <p className="term-condition-text">
                  Bulk, heavy, long-length, or project-based orders may require special transportation
                  arrangements and delivery appointments.
                </p>
                <p className="term-condition-text"><strong>Customers are responsible for ensuring:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Safe site access;</li>
                  <li className="term-condition-subitem">Adequate unloading space;</li>
                  <li className="term-condition-subitem">Sufficient manpower;</li>
                  <li className="term-condition-subitem">
                    Necessary unloading equipment such as forklifts, cranes, or other machinery where required.
                  </li>
                </ul>
                <p className="term-condition-text">
                  Any additional costs arising from site restrictions or unloading requirements shall be borne by
                  the customer.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Split Deliveries</h3>
                <p className="term-condition-text">
                  To avoid unnecessary delays, ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to
                  deliver available items separately when part of an order is not ready for dispatch.
                </p>
                <p className="term-condition-text">
                  Customers will be notified if multiple deliveries are required.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Pre-Order &amp; Special Order Items</h3>
                <p className="term-condition-text">
                  Pre-order and Special Order items may require additional lead time depending on supplier
                  availability and procurement schedules.
                </p>
                <p className="term-condition-text">
                  Estimated delivery dates will be provided upon order confirmation.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Self Pick-Up</h3>
                <p className="term-condition-text">
                  Customers may choose the <strong>Self Pick-Up</strong> option during checkout. Once the order is
                  ready, customers will receive a pickup notification.
                </p>
                <p className="term-condition-text"><strong>Customers must present:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Identification document; and</li>
                  <li className="term-condition-subitem">Order confirmation or pickup notification.</li>
                </ul>
                <p className="term-condition-text">
                  Orders must be collected within <strong>7 working days</strong> from the notification date.
                </p>
                <p className="term-condition-text">
                  Uncollected orders may be subject to storage charges, cancellation fees, or cancellation of the
                  order in accordance with our <em>Refund &amp; Return Policy</em>.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Delivery Rescheduling, Cancellation &amp; Additional Charges</h3>
                <p className="term-condition-text">Additional charges may apply for:</p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Delivery rescheduling;</li>
                  <li className="term-condition-subitem">Change of delivery address;</li>
                  <li className="term-condition-subitem">Delivery cancellation after scheduling;</li>
                  <li className="term-condition-subitem">Redelivery requests;</li>
                  <li className="term-condition-subitem">Waiting or idling time;</li>
                  <li className="term-condition-subitem">Additional unloading services;</li>
                  <li className="term-condition-subitem">Site access restrictions;</li>
                  <li className="term-condition-subitem">Partial unloading of goods.</li>
                </ul>
                <p className="term-condition-text">
                  Applicable charges will be communicated where reasonably practicable.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Inspection of Goods</h3>
                <p className="term-condition-text">
                  Customers are advised to inspect all goods immediately upon delivery or collection.
                </p>
                <p className="term-condition-text">
                  Any shortages, damages, defects, or incorrect items must be reported to ARDENCY CONSTRUCTION
                  &amp; TRADING SDN BHD within <strong>48 hours</strong> of receipt. Claims submitted after this
                  period may not be accepted.
                </p>
                <p className="term-condition-text">
                  Please refer to our <em>Refund &amp; Return Policy</em> for further information.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Contact Us</h3>
                <p className="term-condition-text">
                  For delivery enquiries, order updates, or shipping arrangements, please contact our Customer
                  Service team:
                </p>
                <p className="term-condition-text">
                  <strong>WhatsApp:</strong>{' '}
                  <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">+60 12-482 5199</a><br />
                  <strong>Business Hours:</strong> Monday &ndash; Friday, 9:00 AM &ndash; 5:30 PM (excluding Public Holidays)
                </p>
              </li>
            </ol>
          </div>

          {/* Privacy Policy */}
          <div className={`term-condition-pane ${activeTab === 'privacy' ? 'active' : ''}`}>
            <div className="term-condition-section">
              <h2 className="term-condition-section-title">Privacy Policy</h2>
              <p className="term-condition-text">
                <strong>ARDENCY CONSTRUCTION &amp; TRADING SDN BHD 201701013881(1228046-W)</strong> ("ACTSB",
                "we", "our", or "us") respects your privacy and is committed to protecting your personal
                information. This Privacy Policy explains how we collect, use, store, disclose, and safeguard
                your personal data when you interact with us, whether through our website, stores, mobile
                applications, or other communication channels.
              </p>
              <p className="term-condition-text">
                By accessing our website or providing your personal information to us, you consent to the
                practices described in this Privacy Policy.
              </p>
            </div>

            <ol className="term-condition-list">
              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Scope of Policy</h3>
                <p className="term-condition-text">This Privacy Policy applies to:</p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Customers, suppliers, service providers, contractors, and business partners;</li>
                  <li className="term-condition-subitem">Individuals who interact with us through our website, social media, or events; and</li>
                  <li className="term-condition-subitem">Job applicants and employees (to the extent applicable).</li>
                </ul>
                <p className="term-condition-text">
                  This policy should be read together with our <strong>Terms of Use</strong>.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">What Personal Data We Collect</h3>
                <p className="term-condition-text">We may collect the following categories of personal information:</p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    <strong>Identification Data:</strong> Name, gender, date of birth, age, NRIC/passport number,
                    driving licence details, or other identification details.
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Contact Data:</strong> Personal and business addresses, email addresses, and telephone numbers.
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Transaction Data:</strong> Details of purchases, orders, product preferences, payment
                    history, and delivery information.
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Financial Data:</strong> Bank account details, cheque information, credit card details, and credit history.
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Business/Employment Data:</strong> Employer or company details, job position, business
                    registration details, or employment history (for job applicants).
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Security Data:</strong> CCTV footage, images, and vehicle number plate details
                    (captured in-store, car parks, or collection areas).
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Digital Data:</strong> Cookies, IP addresses, browsing activities on our website,
                    online identifiers, and interactions on social media platforms.
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Event &amp; Promotion Data:</strong> Information submitted when joining promotions,
                    competitions, or in-store events, including family member details.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">How We Collect Your Personal Data</h3>
                <p className="term-condition-text">
                  We may collect your personal information through various channels, including but not limited to:
                </p>
                <p className="term-condition-text"><strong>Directly from you when you:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Purchase or order products;</li>
                  <li className="term-condition-subitem">Contact us for inquiries, complaints, refunds, or feedback;</li>
                  <li className="term-condition-subitem">Subscribe to mailing lists or participate in promotions;</li>
                  <li className="term-condition-subitem">Apply for a credit account, employment, or contractor engagement.</li>
                </ul>
                <p className="term-condition-text"><strong>Indirectly from:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Third-party service providers, product suppliers, and contractors;</li>
                  <li className="term-condition-subitem">Credit reporting agencies and financial institutions;</li>
                  <li className="term-condition-subitem">Publicly available sources (e.g., government agencies, directories, or social media platforms);</li>
                  <li className="term-condition-subitem">Security surveillance systems in our stores and facilities.</li>
                </ul>
                <p className="term-condition-text"><strong>Online activity, including:</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Visits to our website or mobile applications (via cookies and tracking technologies);</li>
                  <li className="term-condition-subitem">Interactions with our digital advertisements or campaigns.</li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Purposes of Collecting and Using Personal Data</h3>
                <p className="term-condition-text">
                  We use your personal information for purposes including, but not limited to:
                </p>

                <p className="term-condition-text"><strong>1. Customer Services &amp; Transactions</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Processing your purchases, payments, invoices, and delivery arrangements.</li>
                  <li className="term-condition-subitem">Handling refunds, returns, recalls, and after-sales support.</li>
                  <li className="term-condition-subitem">Managing product and service inquiries.</li>
                </ul>

                <p className="term-condition-text"><strong>2. Business Operations</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Monitoring sales performance and customer preferences.</li>
                  <li className="term-condition-subitem">Conducting surveys, research, and quality control.</li>
                  <li className="term-condition-subitem">Developing and improving products and services.</li>
                </ul>

                <p className="term-condition-text"><strong>3. Marketing &amp; Communications</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Sending promotional materials, special offers, or newsletters.</li>
                  <li className="term-condition-subitem">Customising advertising (including online behavioural advertising).</li>
                  <li className="term-condition-subitem">Organising events, campaigns, and competitions.</li>
                </ul>

                <p className="term-condition-text"><strong>4. Security &amp; Compliance</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Ensuring health, safety, and security in our stores, pick-up areas, and car parks.</li>
                  <li className="term-condition-subitem">Preventing, detecting, and investigating fraud or unlawful activity.</li>
                  <li className="term-condition-subitem">Complying with legal obligations, regulatory requirements, and court orders.</li>
                </ul>

                <p className="term-condition-text"><strong>5. Business Relationships</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Managing relationships with suppliers, service providers, and contractors.</li>
                  <li className="term-condition-subitem">Evaluating creditworthiness for trade accounts.</li>
                </ul>

                <p className="term-condition-text"><strong>6. Recruitment &amp; Employment</strong></p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">Processing job applications and assessing qualifications.</li>
                  <li className="term-condition-subitem">Engaging employees, contractors, or service providers.</li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Disclosure of Personal Data</h3>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD may disclose your personal information to:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    <strong>Business Partners &amp; Service Providers</strong> &ndash; product suppliers, couriers,
                    payment processors, IT service providers, marketing agencies, contractors, and repair/service agents.
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Financial &amp; Credit Agencies</strong> &ndash; credit reporting bodies, banks, and
                    insurers, for financial transactions or credit assessments.
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Legal &amp; Regulatory Authorities</strong> &ndash; government agencies, regulators,
                    courts, or law enforcement (where required by law).
                  </li>
                  <li className="term-condition-subitem">
                    <strong>Professional Advisors</strong> &ndash; auditors, accountants, or legal advisors.
                  </li>
                </ul>
                <p className="term-condition-text">
                  We require all third parties handling your data to respect the security and confidentiality of
                  your personal information and process it only in accordance with applicable laws.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">International Transfers</h3>
                <p className="term-condition-text">
                  Some of our service providers or related companies may be located outside Malaysia. When
                  transferring your personal information overseas, ARDENCY CONSTRUCTION &amp; TRADING SDN BHD ensures that:
                </p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">The transfer is legally permitted under the PDPA; and</li>
                  <li className="term-condition-subitem">Adequate data protection standards are applied to safeguard your information.</li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Marketing &amp; Opt-Out</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD may send you marketing communications about our
                    products, services, promotions, or events.
                  </li>
                  <li className="term-condition-subitem">
                    You may opt out at any time by clicking the unsubscribe link in our emails or contacting us directly.
                  </li>
                  <li className="term-condition-subitem">
                    Please note: even if you opt out of marketing, we may still send you non-promotional
                    communications (e.g., invoices, service updates, or safety notices).
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Cookies and Tracking Technologies</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    Our website uses cookies and similar technologies to enhance your browsing experience,
                    analyse traffic, and personalise advertising.
                  </li>
                  <li className="term-condition-subitem">
                    You may disable cookies through your browser settings, but some features of our website
                    may not function properly.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Security &amp; Data Retention</h3>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem">
                    ARDENCY CONSTRUCTION &amp; TRADING SDN BHD implements reasonable technical and organisational
                    safeguards (firewalls, encryption, restricted access) to protect personal data from misuse,
                    loss, unauthorised access, or disclosure.
                  </li>
                  <li className="term-condition-subitem">
                    However, no internet transmission or storage system is completely secure, and we cannot
                    guarantee absolute security.
                  </li>
                  <li className="term-condition-subitem">
                    We retain personal data only for as long as necessary to fulfil the purposes outlined in
                    this policy or as required by law.
                  </li>
                </ul>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Your Rights under PDPA 2010</h3>
                <p className="term-condition-text">You have the right to:</p>
                <ul className="term-condition-sublist">
                  <li className="term-condition-subitem"><strong>Access</strong> your personal information held by us;</li>
                  <li className="term-condition-subitem"><strong>Request correction</strong> of inaccurate or incomplete data;</li>
                  <li className="term-condition-subitem"><strong>Withdraw consent</strong> for processing (subject to contractual or legal limitations);</li>
                  <li className="term-condition-subitem"><strong>Restrict processing</strong> or object to direct marketing.</li>
                </ul>
                <p className="term-condition-text">
                  Requests may require identity verification. We will respond within 30 days. If we refuse
                  access or correction, reasons will be provided.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Links to Third-Party Websites</h3>
                <p className="term-condition-text">
                  Our website may contain links to third-party sites. Please note that ARDENCY CONSTRUCTION &amp;
                  TRADING SDN BHD is not responsible for the privacy practices of external websites. We encourage
                  you to read the privacy policies of every website you visit.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Questions and Complaints</h3>
                <p className="term-condition-text">
                  If you have any questions, concerns, or complaints about this Privacy Policy or our handling
                  of your personal data, please contact us:
                </p>
                <p className="term-condition-text">
                  <strong>ARDENCY CONSTRUCTION &amp; TRADING SDN BHD</strong><br />
                  <strong>Address:</strong> No. 21, Jalan Wawasan 2C/KU7, Sungai Kapar Indah, 42200 Kapar, Klang, Selangor.<br />
                  <strong>WhatsApp:</strong> <a href="https://wa.me/60124825199" target="_blank" rel="noopener noreferrer">012-4825199</a><br />
                  <strong>Email:</strong> <a href="mailto:ardency.website@gmail.com">ardency.website@gmail.com</a>
                </p>
                <p className="term-condition-text">
                  We will investigate all complaints and aim to resolve them within 30 days.
                </p>
              </li>

              <li className="term-condition-item">
                <h3 className="term-condition-item-title">Updates to This Policy</h3>
                <p className="term-condition-text">
                  ARDENCY CONSTRUCTION &amp; TRADING SDN BHD reserves the right to update or amend this Privacy
                  Policy at any time. Any changes will be published on our website, and the latest version will
                  always apply. Significant changes may be notified directly to you where appropriate.
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;